import axios from 'axios'
import cors  from 'cors'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getRole, createSign, removeToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  //baseURL: '/api', // url = base url + request url
     baseURL: 'https://vr.51act.cn/api/', 
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})
// service.interceptors.request.use(cors())
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // if(config.mode){
    //   config.baseURL = process.env[config.mode];
    // }
    if(config.method == 'get'){
      let params = config.params
      if(typeof(params) == 'undefined'){
        params = {}
      }
      if(config.auth){
        params = createSign(params)
      }
      config.params = params
    }else if(config.method == 'post'){
      let data = config.data
      if(typeof(data) == 'undefined'){
        data = {}
      }
      if(config.auth){
        data = createSign(data)
      }
      let params = new URLSearchParams()
      for(var i in data) {
        params.append(i, data[i])
      }
      config.data = params
    }

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getRole()
    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.status && res.status !== 'success') {

      Message({
        message: res.code == 'TSV_CODE_0000001'? '二次验证码不正确' : (res.code == 'CAPIMPMMORTE0075'? '该账号已存在' : (res.message || 'Error')),
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 'AUTH_VERIFY_0004' ) {
        // to re-login
        MessageBox.confirm('您已退出登录, 可点击取消保留此页, 或者重新登录', '登陆过期', {
          confirmButtonText: '重新登陆',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
			removeToken()
			router.push({ path: '/login' })
          /* store.dispatch('user/resetToken').then(() => {
            location.reload()
          }) */
        })
      }

      return Promise.reject(new Error(res.message || 'Error'))
    } else if(res.type && res.type.indexOf('.sheet') == -1){
      Message({
        message: '导出失败',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error('导出失败'))
    } else {
      return res
    }
  },
  error => {
    console.log('err:' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
